import { IntegrationSavedSuccessWebController } from '../controller/IntegrationSavedSuccessWebController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { IntegrationType } from '../../types/integration-type';

export class IntegrationSavedSuccessWebComponent extends BaseWebComponentElement {
  public controller!: IntegrationSavedSuccessWebController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrationSavedSuccessWebController,
    });
  }

  public updateBasedOnSensors(integrationName: string, integrationType: IntegrationType, sensors: Object[]) {
    this.controller.updateBasedOnSensors(integrationName, integrationType, sensors);
  }
}
